var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.siteFormData)?_c('site-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText,"site-form-data":_vm.siteFormData,"is-update":true},on:{"submitSiteForm":function($event){return _vm.onSubmit($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }